import React, { ReactNode } from 'react';
import cx from 'classnames';
import { EmptyValuePlaceholder } from './EmptyValuePlaceholder';

export interface LabeledValueProps {
  className?: string;
  label: string;
  value?: ReactNode;
}

export function LabeledValue({ className, label, value }: LabeledValueProps) {
  return (
    <div className={cx(className, 'flex flex-col')}>
      <span className='text-xs v2-text-neutral-500'>{label}</span>
      <span className='text-base v2-text-neutral-900'>
        {!value ? <EmptyValuePlaceholder /> : value}
      </span>
    </div>
  );
}
